import { PropsWithChildren } from "react";
import "./feedback-points.less";

interface Props {
  className?: string
  isCorrect: boolean
}

export default function FeedbackPoints(props: PropsWithChildren<Props>) {
  let className = "feedback-points"
  if (props.className) {
    className += " " + props.className;
  }
  if (props.isCorrect) {
    className += " correct";
  } else {
    className += " incorrect";
  }

  return <div className={className}>
    {props.children}
  </div>
}